import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import { Delta } from 'modules/finance/components/FinancialWorkspace/components/Table/table/Delta'
import { PARSED_ITEMS } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/chart/helpers'

interface GrowthProp {
  index: number
  showTotal: boolean
  items: PARSED_ITEMS
  showDivider: boolean
  showLaborCost: boolean
  showAgreementData: boolean
  showEmployeeExpenses: boolean
}

const Growth = ({
  items,
  index,
  showTotal,
  showDivider,
  showLaborCost,
  showAgreementData,
  showEmployeeExpenses,
}: GrowthProp) => {
  const {
    LABOR_COST,
    AGREEMENT_DATA,
    TOTAL_EXPENSES,
    EMPLOYEE_EXPENSES,
    COMPARISON_LABOR_COST,
    COMPARISON_AGREEMENT_DATA,
    COMPARISON_TOTAL_EXPENSES,
    COMPARISON_EMPLOYEE_EXPENSES,
  } = items

  return (
    <Box flexDirection="column" gap="s8" alignItems="flexEnd">
      <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
        <Text.Normal size="300" weight="bold" color="grey1000">
          {i18n.t('finance.financial_workspace.breakdown_table.growth')}
        </Text.Normal>
      </Box>
      {showAgreementData && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Delta
            mini
            noDiffResult="-"
            secondValue={Number(AGREEMENT_DATA?.[index]?.y) || 0}
            firstValue={Number(COMPARISON_AGREEMENT_DATA?.[index]?.y) || 0}
          />
        </Box>
      )}
      {showDivider && <Box background="grey200" width="full" height="s2" />}
      {showEmployeeExpenses && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Delta
            mini
            noDiffResult="-"
            secondValue={Number(EMPLOYEE_EXPENSES?.[index]?.y) || 0}
            firstValue={Number(COMPARISON_EMPLOYEE_EXPENSES?.[index]?.y) || 0}
          />
        </Box>
      )}
      {showLaborCost && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Delta
            mini
            noDiffResult="-"
            secondValue={Number(LABOR_COST?.[index]?.y) || 0}
            firstValue={Number(COMPARISON_LABOR_COST?.[index]?.y) || 0}
          />
        </Box>
      )}
      {showTotal && (
        <Box gap="s8" minHeight="s24" paddingLeft="s24" flexDirection="row" alignItems="center">
          <Delta
            mini
            noDiffResult="-"
            secondValue={Number(TOTAL_EXPENSES?.[index]?.y) || 0}
            firstValue={Number(COMPARISON_TOTAL_EXPENSES?.[index]?.y) || 0}
          />
        </Box>
      )}
    </Box>
  )
}

export { Growth }
